export default "__VITE_ASSET__DxeUn7pr__"